import {Component, OnInit} from '@angular/core';


@Component({
  selector: 'app-publications',
  templateUrl: './publications.component.html',
  styleUrls: ['./publications.component.scss']
})
export class PublicationsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
